import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/47_halloween_fog/47_halloween_fog"
 * Contains 1 texture(s)
 */
export class Mobile47HalloweenFogAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/47_halloween_fog/47_halloween_fog';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '47_halloween_fog.jpg'
    ] as const;
}
